import React, { useEffect, useState } from "react"
import MainLogoSVG from "../../../images/logo.inline.svg"
import { Link } from "gatsby"
import * as styles from "./Header.module.css"
import SolutionsMenu from "./Solutions/SolutionsMenu"
import ProductsMenu from "./Products/ProductsMenu"
import RolesMenu from "./Roles/RolesMenu"
import classNames from "classnames"
import useDeviceType from "../../../hooks/useDeviceType"
import BargerSVG from "../../../images/menu/barger.inline.svg"
import CloseSVG from "../../../images/menu/close.inline.svg"
import FooterMenu from "../Footer/FooterMenu/FooterMenu"

export enum HeaderTypes {
  SOLUTIONS = "solutions",
  PRODUCTS = "products",
  ROLES = "roles",
}

export type ItemsProps = {
  showOptions: HeaderTypes | undefined
  handleToggleOptions: (type: HeaderTypes) => void
}

const Header = ({ scrolled }: { scrolled?: boolean }) => {
  const [isScrolled, setIsScrolled] = useState(false)
  const [showMenu, setShowMenu] = useState(false)

  const DeviceType = useDeviceType()

  // Mobile Menu
  const [showOptions, setShowOptions] = useState<HeaderTypes>()
  const handleToggleOptions = (type: HeaderTypes) => {
    if (showOptions === type) return setShowOptions(undefined)
    return setShowOptions(type)
  }
  //

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true)
      } else {
        setIsScrolled(false)
      }
    }
    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <header
      className={classNames(styles.container, {
        [styles.scrollHeader]: isScrolled || scrolled,
        [styles.active]: showMenu,
      })}
    >
      <Link to="/" className={styles.mainLogo}>
        <MainLogoSVG />
      </Link>

      <nav className={styles.linksContent}>
        <div className={styles.mobileMenu}>
          <ul className={styles.links}>
            <li
              className={styles.title}
              onClick={() => handleToggleOptions(HeaderTypes.SOLUTIONS)}
            >
              <SolutionsMenu
                showOptions={showOptions}
                handleToggleOptions={handleToggleOptions}
              />
            </li>
            <li
              className={styles.title}
              onClick={() => handleToggleOptions(HeaderTypes.PRODUCTS)}
            >
              <ProductsMenu
                showOptions={showOptions}
                handleToggleOptions={handleToggleOptions}
              />
            </li>

            <li className={classNames(styles.title, styles.employee)}>
              <Link to="/solutions/deskless-employee">Employee Experience</Link>
            </li>

            <li
              className={styles.title}
              onClick={() => handleToggleOptions(HeaderTypes.ROLES)}
            >
              <RolesMenu
                showOptions={showOptions}
                handleToggleOptions={handleToggleOptions}
              />
            </li>
          </ul>
          {(DeviceType === "mobile" || DeviceType === "tablet") && (
            <FooterMenu />
          )}
        </div>

        <Link to="/book-demo">
          <button className={styles.bookDemo}>Request a demo</button>
        </Link>

        {(DeviceType === "mobile" || DeviceType === "tablet") && (
          <button
            className={styles.barger}
            aria-label="barger menu"
            onClick={() => setShowMenu(preShowMenu => !preShowMenu)}
          >
            {showMenu ? <CloseSVG /> : <BargerSVG />}
          </button>
        )}
      </nav>
    </header>
  )
}

export default Header
